export const VendorKeys = {
    id: '_id',
    links: '_links',
    company_url: 'company_url',
    creation_date: 'creation_date',
    description: 'description',
    industries: 'industries',
    label: 'label',
    label_locked: 'label_locked',
    last_update_date: 'last_update_date',
    logo_url: 'logo_url',
    name: 'name',
    object_type: 'object_type',
    org_id: 'org_id',
    published: 'published',
    rss_feed_url: 'rss_feed_url',
    social_media_links: 'social_media_links'
}